import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'

// import Lightbox from 'react-images'
import Gallery from '../../components/Gallery'

import calligraphythumb from '../../assets/images/calligraphy.jpg'
import cizhouthumb from '../../assets/images/features.jpg'
import bronzethumb from '../../assets/images/china/4.jpg'

const DEFAULT_IMAGES = [
  {
    id: '2',
    src: '/archived/calligraphy',
    thumbnail: calligraphythumb,
    caption: 'The Art of Calligraphy',
    description: '',
  },
  {
    id: '2',
    src: '/archived/making-a-cizhou-vessel',
    thumbnail: cizhouthumb,
    caption: 'Making a Cizhou Vessel',
    description: '',
  },
  {
    id: '3',
    src: '/archived/creating-a-bronze-vessel',
    thumbnail: bronzethumb,
    caption: 'Creating a Bronze Vessel',
    description: '',
  }
]

class FeaturesPage extends React.Component {
  constructor() {
    super()

    this.state = {}
  }

  render() {
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteDescription = this.props.data.site.siteMetadata.description
    const siteTitleSub = 'Features'

    return (
      <div>
        <Helmet>
          <title>{`${siteTitleSub} | ${siteTitle}`}</title>
          <meta name="description" content={siteDescription} />
        </Helmet>

        <div id="main">
          <section id="one">
            <header className="major">
              <h1>Features</h1>
            </header>
          </section>

          <section id="two">
            <Gallery
              images={DEFAULT_IMAGES.map(
                ({ id, src, thumbnail, caption, description }) => ({
                  src,
                  thumbnail,
                  caption,
                  description,
                })
              )}
            />
          </section>
        </div>
      </div>
    )
  }
}

export default FeaturesPage

export const pageTitleQuery = graphql`
  query featuresPageTitleQuery {
    site {
      ...PageQueryFrag
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/features/features.js